import React, { Fragment, useState, useEffect } from "react";
import ScrollTop from "../components/ScrollTop";

import Footer from "./footers/Footer";
import HeadersLayouts from "./headers/HeadersLayout";
import { useMediaQuery } from "@mui/material";

const Layouts = ({
  children,
  footer,
  headerTopbar,
  position,
  noNewsletters,
  noheader,
  noFooter,
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const isMobile = useMediaQuery("(max-width:868px)");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Fragment>
      {/* Conditionally render the header if `noheader` is not true */}
      {noheader && (
        <HeadersLayouts
          headerTopbar={headerTopbar}
          position={position}
          isSticky={isSticky}
        />
      )}

      {/* Render the main content (children passed into the layout) */}
      <main style={{ marginTop: !isMobile && 70 }}>{children}</main>

      {/* Conditionally render the footer if `noFooter` is not true */}
      {!noFooter && <Footer footer={footer} noNewsletters={noNewsletters} />}

      {/* Scroll to Top button */}
      <ScrollTop />
    </Fragment>
  );
};

export default Layouts;
